import React, { Component } from 'react'
import { Bar, Chart } from 'react-chartjs-2'
import zoom from 'chartjs-plugin-zoom';
import YearPicker from "react-year-picker"
import { Container, Row, Col } from 'react-bootstrap'
import api from '../api/index.js'
import '../styles/bar.css'

const colors = ['rgb(255, 99, 132)', 'rgb(54, 162, 235)', 'rgb(75, 192, 192)']
const yearPickerContainer = {
    zIndex: 20,
    width: 'fit-content',
    position: 'relative'
  }

const extractTagihanData = (data, key, filter) => {
    const result = data.filter(filter).map(x => x[key])
    return result
}

// buat global styling nanti
const getDataset = (label, color, datas) => {
    const dataset = {
        label,
        backgroundColor: color,
        data: datas
    }
    return dataset
}

const getData = (rawData, components, labels, id, year) => {
    // rawData: data dari database
    // components: yAxis pengen ada apa aja
    // labels: xAxis pengen ada apa aja
    // flow: ambil data xAxis untuk tiap label, trus jadiin data jadi
    let yColors = colors
    let datasets = []
    components.forEach((yAxis, idx) => {
        let data = []
        labels.forEach(xAxis => {
            let num = extractTagihanData(rawData, yAxis, x => x[id] === xAxis && x['bulan'].slice(0,4) === year.toString())
            data.push(num.reduce((a, b) => a + b, 0))
        })
        datasets.push(getDataset(yAxis, yColors[idx], data))
    })
    const data = {
        labels,
        datasets
    }
    console.log(data)
    return data
}

const options = {
    legend: {
        onClick: (e) => e.stopPropagation()
    },
    zoom: {
        enabled: true,
        mode: 'x',
        speed: 0.1,
        sensitivity: 1,
    },
    pan: {
        enabled: true,
        mode: 'x',
        speed: 1,
    },
    scales: {
        yAxes: [
            {
                stacked: true,
                ticks: {
                    beginAtZero: true,
                },
            },
        ],
        xAxes: [
            {
                stacked: true,
                ticks: {
                    min: 3,
                    max: 10,
                }
            },
        ],
    },
  }

export default class BarDemo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: getData([], [], [], 'name_building', new Date().getFullYear()),
            year: new Date().getFullYear()-1,
            checks: {
                lwbp: true,
                wbp: true
            }
        }
        this.chart = React.createRef();
        this.rawData = []
        this.buildings = []
        this.retrievedYear = []
    }

    componentWillMount() {
        Chart.plugins.register(zoom)
      }

    componentDidMount = async () => {
        this.getFromDatabase(new Date().getFullYear()-1)
    }

    getTop10Pelanggan = data => {
        let temp = {}
        data.forEach(item => {
            if (temp.hasOwnProperty(item['name_building'])) {
                temp[item['name_building']] += item['jumlah tagihan (Rp)']
            } else {
                temp[item['name_building']] = item['jumlah tagihan (Rp)']
            }
        })
        let sorted = Object.entries(temp)
            .sort(([,a],[,b]) => b-a)
        let pelanggan = Array.from(new Set(sorted.map(x => x[0]))).slice(0,10)
        return pelanggan
    }

    getFromDatabase = async year => {
        let data = []
        let criteria = {
            location: "Kampus Ganesa",
            month: "1",
            year: year.toString()
        }
        for (let i = 1; i <= 12; i++){
            criteria.month = i < 10 ? '0' + i.toString() : i.toString()
            await api.getListrikForGraphBar(criteria)
                .then(res => {
                    data = [...data, ...res.data.data]
                })
                .catch(err => {
                    console.log(err)
                }) 
        }

        this.rawData = [...data]
        this.buildings = this.getTop10Pelanggan(this.rawData)
        let checked = this.getChecked()
        this.setState({
            data: getData(this.rawData, checked, this.buildings, 'name_building', this.state.year)
        })
    }

    convertKey2Db = (key) => {
        if (key === 'lwbp')
            return 'LBWP (Rp)'
        else if (key === 'wbp')
            return 'WBP (Rp)'
    }

    getChecked = () => {
        let checked = []
        for (const [key, value] of Object.entries(this.state.checks)) {
            if (value)
                checked.push(this.convertKey2Db(key))
        }
        return checked
    }

    handleChecked = (e) => {
        let name = e.target.value
        this.setState(prevState => ({
            checks: {
                ...prevState.checks,
                [name]: !prevState.checks[name]
            }
        }), () => this.handleInputChange())
    }

    handleInputChange = () => {
        let checked = this.getChecked()
        const thisData = getData(this.rawData, checked, this.buildings, 'name_building', this.state.year)
    
        this.setState({
            data: thisData,
        })
    }

    changeYearPicker = async value => {
        if (!this.retrievedYear.includes(value)) {
            await this.getFromDatabase(value)
        }
        let checked = this.getChecked()
        const thisData = getData(this.rawData, checked, this.buildings, 'name_building', value)
        console.log(thisData)
        
        this.setState({
            year: value,
            data: thisData
        });
    }

    
    render() {
        return (
        <Container>

            <Row>
                <h3>Tahun {this.state.year}</h3>
            </Row>

            <Row>
                <div className="ml-auto wrapper-year-picker" style={yearPickerContainer}>
                    <YearPicker className="ml-auto" onChange={value => this.changeYearPicker(value)} />
                </div>
            </Row>
            <Row className="px-5 scroll-chart">
                <h4>Komposisi Pengeluaran</h4>
                <div className="bar-chart">
                    <Bar ref={this.chart} data={this.state.data} options={options} redraw />
                </div>
                <Col md={6}>
                    <label>
                        <input
                            name="compositions"
                            type="checkbox"
                            value="lwbp"
                            className="mr-2"
                            checked={this.state.checks.lwbp}
                            onChange={this.handleChecked} />
                        LWBP (Rp)
                    </label>
                </Col>

                <Col md={6}>
                    <label>
                        <input
                            name="compositions"
                            type="checkbox"
                            value="wbp"
                            className="mr-2"
                            checked={this.state.checks.wbp}
                            onChange={this.handleChecked} />
                        WBP (Rp)
                    </label>
                </Col>
            </Row>
        </Container>

        )
    }
}
